import { useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useLocationState } from 'src/actuators/user-input/useLocationState.ts';

export const PageLegacy = ({ pathname }: { pathname: string }) => {
    const navigate = useNavigate();
    const { page, actuatorLabel } = useParams();
    const [locationState, setLocationState] = useLocationState();

    useEffect(() => {
        const search = setLocationState({
            ...locationState,
            actuatorPage: page !== undefined ? page : locationState.actuatorPage,
            actuatorLabel: actuatorLabel !== undefined ? actuatorLabel : locationState.actuatorLabel,
        });
        navigate({
            pathname,
            search: search.toString(),
        });
    }, [actuatorLabel, locationState, navigate, page, pathname, setLocationState]);

    return 'redirecting';
};
